/**
 * KORERIG scroll reveal
 *
 * Blokken met .kr-reveal staan op opacity 0 tot er data-shown op staat. Die
 * logica zat alleen in kr-product.js, en dat bestand laadt uitsluitend op de
 * productpagina. De homepage gebruikt kr-usecases en kr-feature ook, waardoor
 * die blokken daar onzichtbaar bleven staan. Dit bestand doet alleen de reveal
 * en is veilig om meer dan een keer in te laden: elk element wordt hooguit een
 * keer waargenomen en daarna losgelaten.
 */

/** @returns {boolean} */
function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initReveal() {
  const targets = document.querySelectorAll('.kr-reveal:not([data-shown])');
  if (targets.length === 0) return;

  if (prefersReducedMotion()) {
    for (const target of targets) /** @type {HTMLElement} */ (target).dataset.shown = 'true';
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        /** @type {HTMLElement} */ (entry.target).dataset.shown = 'true';
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  for (const target of targets) observer.observe(target);
}

initReveal();

// Shopify theme editor: secties worden opnieuw gerenderd, dus opnieuw binden.
if (!window.__krRevealBound) {
  window.__krRevealBound = true;
  document.addEventListener('shopify:section:load', initReveal);
}
